import { Typography } from "@mui/material";
import { BaseBTN } from "src/components/ui";
import { LoginIcon } from "src/components/ui/svgIcon/CustomIcons";
import {useNavigate } from "react-router-dom";
const ButtonWithDynamicLink = ({ children, newTheme }) => {
  const navigate = useNavigate();
  function navigateUser() {
    navigate("/");
  }

  return (
    <BaseBTN onClick={navigateUser} sx={{ width: 300, backgroundColor: newTheme.text.color.primary, borderRadius: 1 }}>
      <LoginIcon color={"#0B2544"} />
      <Typography variant="subtitle2" ml={1} color={"#0B2544"}>
        {children}
      </Typography>
    </BaseBTN>
  );
};

export default ButtonWithDynamicLink;
